const initialState = [];
export default function scribeTrainings(state = initialState, action) {
    switch (action.type) {
        case 'FETCH_SCRIBE_TRAINING_SUCCESS':
            return action.trainings;
        default:
            // eslint-disable-next-line no-unused-expressions
            action;
            return state;
    }
}
